import React, { useEffect } from "react";
import useCalendarSale from "./../CalendarSale/hooks/useCalendarSale";
import "./style.scss";
import "../../../style/feature.scss";
import "../../../style/block.scss";
import "../../../style/typography.scss";
import "../../../style/calendar.scss";
import MixedTicket from "../MixedTicket";
import { useTranslation } from "react-i18next";
import capitalizeFirstLetter from "../../../utils/capitalizeFirstLetter";

const ThreeStepSale: React.FC = () => {
  const { getExercisesAvailable } = useCalendarSale();
  const { t } = useTranslation();

  useEffect(() => {
    getExercisesAvailable();
  }, []);

  return (
    <React.Fragment>
      <div>
        <div className="headline">
          <h1>
            {/* {exerciseSaleHeader} */}
            {capitalizeFirstLetter(t("bilety"))}
          </h1>
          <div className="line"></div>
        </div>

        <MixedTicket />

        {/* {exerciseAvailAble && (
          <div className="exercise-available-wrapper">
            {exerciseAvailAble.map((item, index) => (
              <React.Fragment>
                {(item.name === "Muzeum Edukacji Ekologicznej" ||
                  // item.name === "Muzeum Przyrodnicze" ||
                  item.name === "Skamieniałe Miasto") && <SingleAvailAbleExercise exercise={item} key={index} />}
              </React.Fragment>
            ))}
          </div>
        )} */}
      </div>
    </React.Fragment>
  );
};

export default ThreeStepSale;
